<template>
    <div class="language-settings">
        <ul class="list-unstyled">
            <template v-for="language in languageList">
                <li :class="{'active': language === currentLanguage}">
                    <a class="language-settings__link"
                       :href="generateUrl(language, false)"
                       @click.prevent="changeLanguage($event, generateUrl(language, true), language)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="flag-icon">
                            <use :xmlns:xlink="'http://www.w3.org/1999/xlink'" :xlink:href="'#' + language"></use>
                        </svg>
                        {{ $translate('Ceres::Template.header' + capitalize(language)) }}
                    </a>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
import {isNullOrUndefined} from 'ceres/app/helper/utils';
import {jQueryGet} from '../../helper/jQueryGet';

export default
{
    props: {
        languageList: Array,
        languageUrls: null,
    },
    data() {
        return {
            currentLanguage: App.language,
            defaultLanguage: App.defaultLanguage
        }
    },
    methods: {
        /**
         * The withCurrency parameter is for the currency get parameter in the url. If this
         * is set to true, a trailing slash is always appended. In some cases
         * switch is not working correct without trailing slash.
         *
         * @param language
         * @param withCurrency
         * @returns {string}
         */
        generateUrl(language, withCurrency) {

            let url       = '/';
            let _language = language;

            if(_language === 'se') {
                _language = 'sv';
            }

            if(!isNullOrUndefined(this.languageUrls[_language])) {

                url = this.languageUrls[_language];

                if(withCurrency || (new URL(url).pathname !== '/' && App.urlTrailingSlash)) {
                    url += '/';
                }

                url += document.location.search;

            }else if(language !== this.defaultLanguage) {
                url = '/' + language
                    + (withCurrency || (window.location.pathname !== '/' && App.urlTrailingSlash) ? '/' : '');
            }

            if(withCurrency && url.indexOf('currency=') === -1) {
                url += url.indexOf('?') > -1 ? '&' : '?';
                url += 'currency=' + App.currencyCode;
            }

            return url;
        },
        changeLanguage($event, url, lang) {

            document.getElementById('js--country-settings')
                .parentElement.classList.add('country-settings--loader');

            /**
             * In some cases plenty gives the URL without window.location.origin
             */
            if(url.startsWith('/')) {
                url = window.location.origin + url;
            }

            /**
             * Use custom jQuery get request, because plenty ApiService crashes if lang URL is 404. The full URL is
             * necessary for the request, otherwise default delivery country is set for default language.
             */
            jQueryGet(url)
                .always(() => {

                    /**
                     * The default lang needs two api page calls otherwise default currency is set
                     */
                    if(lang === App.defaultLanguage) {
                        jQueryGet(url)
                            .always(() => {
                                this.setShippingCountryAndUrl($event.target.href);
                            });
                    }else {
                        this.setShippingCountryAndUrl($event.target.href);
                    }
                });
        },
        setShippingCountryAndUrl(url) {
            this.$store.dispatch('selectShippingCountry', {
                shippingCountryId: App.initialData.shippingCountryId,
                openBasketPreview: false
            }).then(() => {
                window.location = url;
            });
        },
        capitalize(value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    }
}
</script>
